<template>
    <svg version="1.1" id="Vector_Smart_Object_xA0_Image_00000062154933384968421160000002740412076686256541_"
         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000"
         style="enable-background:new 0 0 1000 1000;" xml:space="preserve">
<image style="overflow:visible;" width="954" height="814" id="Vector_Smart_Object_xA0_Image"
       xlink:href="https://static.supsis.live/common/aydinli/assets/CacherelLogo.svg" transform="matrix(1 0 0 1 23 93)">
</image>
</svg>
</template>
<script>
export default {
    name: "CacherelLogo",
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/V2/uspaV2/asset/CacherelLogo.vue